import React from "react"
import { Link } from "gatsby"
import { motion } from "framer-motion"
import { springVariants, springViewport } from '../utils/framerVariants';

const Footer = () => {

  const isGerman = typeof window !== 'undefined' && window.location.pathname.includes('/de');

  return (
    <motion.footer className="mx-auto max-w-none px-16 md:px-8 container mb-24 lg:mb-32 mt-24 md:mt-0" variants={springVariants} initial="invisible" whileInView="visible" viewport={springViewport}>
      <nav className="flex flex-col gap-y-12 md:gap-y-16">
        <div className="flex justify-center gap-x-4 md:gap-x-6">
          <div>
            <a href="https://facebook.com/allianzfdn" target="_blank" rel="noreferrer" title="Facebook">
              <svg xmlns="http://www.w3.org/2000/svg" className="w-8 hover:fill-black/60 transition-color duration-200" viewBox="0 0 24 24"><path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm3 8h-1.35c-.538 0-.65.221-.65.778v1.222h2l-.209 2h-1.791v7h-3v-7h-2v-2h2v-2.308c0-1.769.931-2.692 3.029-2.692h1.971v3z"/></svg>
            </a>
          </div>
          <div>
            <a href="https://x.com/allianzfdn" target="_blank" rel="noreferrer" title="X">
              <svg viewBox="0 0 24 24" className="w-8 hover:fill-black/60 transition-color duration-200" xmlns="http://www.w3.org/2000/svg">
                <circle  cx="12" cy="12" r="12"/>
                <path d="m4.608 5.048 5.736 7.669-5.772 6.235H5.87l5.053-5.46 4.083 5.46h4.421l-6.059-8.1 5.373-5.804h-1.3l-4.653 5.027-3.76-5.027H4.608Zm1.91.956H8.55l8.968 11.991h-2.03L6.518 6.005Z" fill="#FFF"/>
              </svg>
            </a>
          </div>
          <div>
            <a href="https://instagram.com/allianzfdn" target="_blank" rel="noreferrer" title="Instagram">
              <svg xmlns="http://www.w3.org/2000/svg" className="w-8 hover:fill-black/60 transition-color duration-200" viewBox="0 0 24 24"><path d="M14.829 6.302c-.738-.034-.96-.04-2.829-.04s-2.09.007-2.828.04c-1.899.087-2.783.986-2.87 2.87-.033.738-.041.959-.041 2.828s.008 2.09.041 2.829c.087 1.879.967 2.783 2.87 2.87.737.033.959.041 2.828.041 1.87 0 2.091-.007 2.829-.041 1.899-.086 2.782-.988 2.87-2.87.033-.738.04-.96.04-2.829s-.007-2.09-.04-2.828c-.088-1.883-.973-2.783-2.87-2.87zm-2.829 9.293c-1.985 0-3.595-1.609-3.595-3.595 0-1.985 1.61-3.594 3.595-3.594s3.595 1.609 3.595 3.594c0 1.985-1.61 3.595-3.595 3.595zm3.737-6.491c-.464 0-.84-.376-.84-.84 0-.464.376-.84.84-.84.464 0 .84.376.84.84 0 .463-.376.84-.84.84zm-1.404 2.896c0 1.289-1.045 2.333-2.333 2.333s-2.333-1.044-2.333-2.333c0-1.289 1.045-2.333 2.333-2.333s2.333 1.044 2.333 2.333zm-2.333-12c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm6.958 14.886c-.115 2.545-1.532 3.955-4.071 4.072-.747.034-.986.042-2.887.042s-2.139-.008-2.886-.042c-2.544-.117-3.955-1.529-4.072-4.072-.034-.746-.042-.985-.042-2.886 0-1.901.008-2.139.042-2.886.117-2.544 1.529-3.955 4.072-4.071.747-.035.985-.043 2.886-.043s2.14.008 2.887.043c2.545.117 3.957 1.532 4.071 4.071.034.747.042.985.042 2.886 0 1.901-.008 2.14-.042 2.886z"/></svg>
            </a>
          </div>
          <div>
            <a href="https://de.linkedin.com/company/allianzfdn" target="_blank" rel="noreferrer" title="LinkedIn">
              <svg xmlns="http://www.w3.org/2000/svg" className="w-8 hover:fill-black/60 transition-color duration-200" viewBox="0 0 24 24"><path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-2 16h-2v-6h2v6zm-1-6.891c-.607 0-1.1-.496-1.1-1.109 0-.612.492-1.109 1.1-1.109s1.1.497 1.1 1.109c0 .613-.493 1.109-1.1 1.109zm8 6.891h-1.998v-2.861c0-1.881-2.002-1.722-2.002 0v2.861h-2v-6h2v1.093c.872-1.616 4-1.736 4 1.548v3.359z"/></svg>
            </a>
          </div>
        </div>
        <div className="flex justify-center gap-x-8 md:gap-x-16 flex-wrap gap-y-6">
          <div>
            <a href="https://subscribe.newsletter2go.com/?n2g=ewtmqqk7-k797qthj-96v" target="_blank" rel="noreferrer" title="Newsletter"
              className="text-text leading-none tracking-text font-medium hover:font-normal">
              Newsletter
            </a>
          </div>
          <div>
            <Link to={`${isGerman ? '/de/contact' : '/contact'}`} title={`${isGerman ? 'Kontakt' : 'Get in touch'}`} className="text-text leading-none tracking-text font-medium hover:font-normal">
              {`${isGerman ? 'Kontakt' : 'Get in touch'}`}
            </Link>
          </div>
          <div>
            <Link to={`${isGerman ? '/de/jobs' : '/jobs'}`} title="Jobs" className="text-text leading-none tracking-text font-medium hover:font-normal">
              Jobs
            </Link>
          </div>
          <div>
            <Link to={`${isGerman ? '/de/privacy' : '/privacy'}`} title={`${isGerman ? 'Datenschutz' : 'Privacy policy'}`} className="text-text leading-none tracking-text font-medium hover:font-normal">
              {`${isGerman ? 'Datenschutz' : 'Privacy policy'}`}
            </Link>
          </div>
          <div>
            <Link to={`${isGerman ? '/de/legal-notice' : '/legal-notice'}`} title={`${isGerman ? 'Impressum' : 'Legal notice'}`} className="text-text leading-none tracking-text font-medium hover:font-normal">
              {`${isGerman ? 'Impressum' : 'Legal notice'}`}
            </Link>
          </div>
        </div>
      </nav>
    </motion.footer>
  )
}

export default Footer
